import IntegrationMessagesView from './IntegrationMessagesView';

const DevInboxView = () => (
  <IntegrationMessagesView
    box="inbox"
    title="Inbox"
    description="Integrationsbeskeder modtaget fra D365 og behandlet af TaskService"
  />
);

export default DevInboxView;
